import { selectCurrentHotelId } from 'accessors'
import { useRef, useState } from 'react'
import { useSelector } from 'react-redux'

import SiteIcon from '../../../components/ReusableComponents/SiteIcon/index'
import { AdminHelper } from './AdminHelper'

export const Subsidiary = ({ hotel, handleSelect, isInternalAdmin }) => {
  const targetRef = useRef()
  const [pos, setPos] = useState({})
  const [isHovering, setHovering] = useState(false)

  const currentHotelId = useSelector(selectCurrentHotelId)

  return (
    <li
      key={hotel.subsidiaryId}
      ref={targetRef}
      onMouseOver={() => {
        if (!isHovering) {
          setPos(targetRef.current && targetRef.current.getBoundingClientRect())
        }
        setHovering(true)
      }}
      onMouseOut={() => setHovering(false)}
    >
      <button
        onClick={() => handleSelect(hotel)}
        className={currentHotelId === hotel.subsidiaryId ? 'hotel-selector-active' : ''}
      >
        <div className="hotel-selector__hotel-icon-group">
          <SiteIcon url={hotel.websiteAddress} />
          {isInternalAdmin && (
            <AdminHelper
              subsidiary={hotel}
              pos={pos}
              showTooltip={isHovering}
              subsidiaryId={hotel.subsidiaryId}
            />
          )}
        </div>
        <div className="hotel-selector__hotel-name-group" title={hotel.subsidiaryName}>
          <div className="hotel-selector__url">{hotel.brand}</div>
          <div className="hotel-selector__name">
            {hotel.displayId && isInternalAdmin && (
              <span className="hotel-selector__displayId">#{hotel.displayId}</span>
            )}
            {hotel.shortName}
          </div>
        </div>
      </button>
    </li>
  )
}
